export const shouldLoad = () => !!document.querySelector('[data-controller=input]');
